export const toJSON = (r: Response) => r.json();
